/**
 * `accounts` — une personne (base plateforme, 4.1).
 */
import { z } from 'zod';
import { CHAMPS_DOCUMENT, emailSchema, idSchema, langueSchema, withAudit } from './commun.js';
/** État d'un compte. */
export const ETATS_COMPTE = ['actif', 'suspendu', 'archive'];
export const etatCompteSchema = z.enum(ETATS_COMPTE);
/** Double authentification TOTP (reprise du socle Venio, 7.8). */
export const deuxFacteursSchema = z.object({
    actif: z.boolean().default(false),
    secretChiffre: z.string().optional(),
    codesSecoursHash: z.array(z.string()).default([]),
    enroleLe: z.date().optional(),
});
export const accountSchema = withAudit(z.object({
    _id: idSchema,
    email: emailSchema,
    motDePasseHash: z.string(),
    nom: z.string(),
    langue: langueSchema.default('fr'),
    deuxFacteurs: deuxFacteursSchema,
    dernierAcces: z.date().optional(),
    etat: etatCompteSchema.default('actif'),
}));
export const accountCreationSchema = accountSchema
    .omit({ ...CHAMPS_DOCUMENT, motDePasseHash: true, dernierAcces: true })
    .extend({ motDePasse: z.string().min(12, 'Douze caractères au minimum.') });
export const accountMiseAJourSchema = accountCreationSchema.partial();
//# sourceMappingURL=accounts.js.map